import { InfoOutlined } from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import {
  LIFECYCLE_BILLING,
  LIFECYCLE_REFRESH,
  LIFECYCLE_RENEWAL,
} from "./constants";
import { getLifecycleManagementEventTypeColor } from "./getLifecycleManagementEventTypeColor";

function getLifecycleEventTypeTooltipText(eventType: string): React.ReactNode {
  switch (eventType) {
    case LIFECYCLE_BILLING:
      return <>A billing event with <b>no renewal or refresh impact</b> (e.g., annual invoice on a multi-year order).</>;
    case LIFECYCLE_REFRESH:
      return <>Assets reaching the end of their usable life. Refresh cycles can be adjusted in Lifecycle Policies.</>;
    case LIFECYCLE_RENEWAL:
      return <>Assets with a <b>publisher defined expiration</b> date.</>;
    default:
      return;
  }
}

export const LifecycleEventTypeTooltip = ({eventType} : {eventType: string}) => {
  const tooltipText = getLifecycleEventTypeTooltipText(eventType);

  const chip = (
    <Chip
      label={
        <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
          <span>{eventType}</span>
          {tooltipText && <InfoOutlined sx={{ fontSize: 15, color: "gray" }} />}
        </span>
      }
      size="small"
      variant="outlined"
      sx={{
        borderColor: getLifecycleManagementEventTypeColor(eventType),
      }}
    />
  );

  if (!tooltipText) {
    return chip;
  }

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      {chip}
    </Tooltip>
  );
};
